import {useEffect} from "react"
import {batch, useSignal} from "@preact/signals-react"
import {useAppToast} from "@ui-seeker/app"
import {postSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"
import {customerIDForm, isLoadingNewProducts, newProductsTableData, unmatchedNewProductsFilters} from "../@signals"


export default function useUnmatchedNewProductsData() {
	const { showToast } = useAppToast()

    const isEmpty = useSignal(false)

    useEffect(() => {
		if (isLoadingNewProducts.value) batch(() => {
			newProductsTableData.value = []
			postSubmit(`${BACKEND_APIS.UNMATCHED}/new-products/raw-data`, { ...unmatchedNewProductsFilters.value }).then(res => {
				if (!res?.table.length) isEmpty.value = true
				newProductsTableData.value = res.table
				customerIDForm.value=res.customerID
			}).catch(() => showToast.error()
			).finally(() => {
				isLoadingNewProducts.value = false
			})
		})
	}, [isLoadingNewProducts.value])

	return {
        isEmpty: isEmpty.value
	}
}